import { useQuery } from "@tanstack/react-query"
import { getSnippetData } from "./apiCall"
import { useAccessibility } from "../context/AccessibilityContext"


export default function NavigationContentQuery () {
    const { easySpeech } = useAccessibility()

    const {
            data: navigationContent,
            isLoading: navigationContentIsLoading,
            error: navigationContentError,
        } = useQuery({
            queryKey: ["snippet-navigation"],
            queryFn: () => getSnippetData({ lang: easySpeech ? "/simple" : "/de", snippet: "navigation" }),
        })
    return { navigationContent, navigationContentError, navigationContentIsLoading }
}
